import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { SortablejsModule } from "@maksim_m/ngx-sortablejs";

import { NgCircleProgressModule } from "ng-circle-progress";
import { InlineSVGModule } from "ng-inline-svg-2";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { QuillModule } from "ngx-quill";
import { routes } from "./app.routes";
import { provideAuth } from "./core/auth/auth.providers";
import { GlobalErrorLoggingService } from "./global-error-logging.service";
import { NetworkResponseErrorInterceptor } from "./network-response-error.interceptor";
import { NetworkResponseTimeLoggingInterceptor } from "./network-response-time-logging-interceptor";
import { SiteHeaderInterceptor } from "./site-header.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAuth(),
    importProvidersFrom(
      NgCircleProgressModule.forRoot({}),
      NgxDaterangepickerMd.forRoot(),
      InlineSVGModule.forRoot(),
      QuillModule.forRoot(),
      SortablejsModule.forRoot({
        animation: 150,
      }),
    ),
    {
      provide: APP_BASE_HREF,
      useFactory: (platformLocation: PlatformLocation) =>
        platformLocation.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkResponseErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkResponseTimeLoggingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SiteHeaderInterceptor,
      multi: true,
    },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false },
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorLoggingService,
    },
  ],
};
